import {
  ChallengeCustomerType,
  humanizeChallengeCustomerType,
} from '../../constants/challengeCustomerType';

export const getHumanizeChallengeCustomerType = (customerType: ChallengeCustomerType) => {
  return humanizeChallengeCustomerType[customerType] ?? customerType;
};
